module.exports = __webpack_public_path__ + "static/img/(1954)_34'ForAPianist_London.a5794e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/thumbs/(1954)_34'ForAPianist_London.jpg
// module id = Wi2c
// module chunks = 0